// Variant option buttons (#32). The radios drive the theme's existing option
// <select> (hidden via CSS), so theme.js keeps handling price, URL, the
// hidden variant id and the add-to-basket / sold out state.
class VariantButtons extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-ref-select]');
    if (!this.select) return;

    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-ref-input]')) return;
      this.syncSelect(event.target.value);
    });

    // The buttons show before this module loads, so pick up any choice made
    // in the meantime.
    const checked = this.querySelector('[data-ref-input]:checked');
    if (checked && checked.value !== this.select.value) this.syncSelect(checked.value);
  }

  syncSelect(value) {
    this.select.value = value;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('component-variant-buttons', VariantButtons);
